import React from 'react';
import { Button } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        body: {
            position: 'relative',
            background: '#FBFBFF',
            borderRadius: '0 0 16px 16px',
            boxSizing: 'border-box',
            padding: '0 24px',
            width: '100%'
        },
        title: {
            boxSizing: 'border-box',
            fontSize: '24px',
            lineHeight: 1.25,
            margin: '0 0 8px',
            padding: '0 40px',
            textAlign: 'center',
            width: '100%'
        },
        bodyItems: {
            position: 'relative',
            top: '-30px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px'
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#EBEBFF',
            borderRadius: '16px',
            color: '#1F2152',
            paddingTop: '64px'
        },
        photoContainer: {
            backgroundColor: '#FFFFFF',
            position: 'absolute',
            left: 'calc(50% - 50px)',
            top: '-48px',
            borderRadius: '50%',
            height: '100px',
            width: '100px',
            '& img': {
                borderRadius: '50%',
                height: '100%',
                objectFit: 'cover',
                width: '100%'
            }
        },
        subtitle: {
            boxSizing: 'border-box',
            fontSize: '18px',
            fontWeight: 200,
            lineHeight: 1.4,
            padding: '8px 40px 64px',
            textAlign: 'center',
            width: '100%'
        },
        option: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '20px',
            borderRadius: '8px',
            backgroundColor: '#FFFFFF',
            cursor: 'pointer',
            transition: 'all 0.2s',
            textTransform: 'none',
            textAlign: 'left',
            color: '#1F2152',
            fontSize: '16px',
            fontWeight: 500,
            width: '100%',
            boxShadow: '0px 8px 16px 4px #0000000D',
            '&:hover': {
                backgroundColor: '#F5F5F5',
                borderColor: '#999DFF'
            }
        },
        optionText: {
            color: '#1F2152',
            flex: 1,
            fontSize: '16px',
            fontWeight: 600,
            textAlign: 'left'
        },
        arrowIcon: {
            color: '#999DFF',
            fontSize: '18px'
        }
    })
);

type ReactivateMembershipOptionBodyProps = {
    mobile_photo?: string;
    title?: string;
    subtext?: string;
    option1Text?: string;
    option2Text?: string;
    onSelectOption: (sameDeployment: boolean) => void;
};

const ReactivateMembershipOptionBody: React.FC<ReactivateMembershipOptionBodyProps> = ({
    mobile_photo = '',
    title,
    subtext,
    option1Text,
    option2Text,
    onSelectOption
}) => {
    const classes = useStyles();

    const handleOptionClick = (option: string) => {
        onSelectOption(option === 'option1');
    };

    const defaultPhoto = '/intake-profile-pic-default.png';
    const photoSrc = mobile_photo || defaultPhoto;

    return (
        <div>
            <div className={classes.photoContainer}>
                <img src={photoSrc} alt="profile" />
            </div>
            <div className={classes.content}>
                {title && <h2 className={classes.title}>{title}</h2>}
                {subtext && (
                    <span className={classes.subtitle}>
                        {subtext}
                    </span>
                )}
                <div className={classes.body}>
                    <div className={classes.bodyItems}>
                        <Button
                            className={classes.option}
                            onClick={() => handleOptionClick('option1')}
                        >
                            <span className={classes.optionText}>{option1Text}</span>
                            <i className={`far fa-chevron-right ${classes.arrowIcon}`} />
                        </Button>
                        <Button
                            className={classes.option}
                            onClick={() => handleOptionClick('option2')}
                        >
                            <span className={classes.optionText}>{option2Text}</span>
                            <i className={`far fa-chevron-right ${classes.arrowIcon}`} />
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReactivateMembershipOptionBody;
